import { Grid } from '@material-ui/core';
import SkeletonPulse from './SkeletonPulse';

interface PodcastSkeletonLoaderType {
  backgroundColor?: string;
}

const PodcastSkeletonLoader = ({
  backgroundColor
}: PodcastSkeletonLoaderType) => {
  return (
    <Grid container spacing={1} direction="column">
      <Grid item>
        <SkeletonPulse
          width="120"
          height="120"
          backgroundColor={backgroundColor}
        />
      </Grid>
      <Grid item>
        <SkeletonPulse
          width="120"
          height="12"
          backgroundColor={backgroundColor}
        />
      </Grid>
      <Grid item>
        <SkeletonPulse
          width="80"
          height="12"
          backgroundColor={backgroundColor}
        />
      </Grid>
    </Grid>
  );
};

export default PodcastSkeletonLoader;
